export const normalizeLiveStatusFilters = filters =>
  Object.entries(filters ?? {}).reduce((result, [key, value]) => {
    if (value === undefined || value === null || value === '' || (Array.isArray(value) && !value.length)) return result

    // CSV prevents axios from serializing an array as `key[]`, which v2 does not accept.
    result[key] = Array.isArray(value) ? value.join(',') : value
    return result
  }, {})
